const COMPONENT_BOX_SHOW = 'COMPONENT_BOX_SHOW'
const COMPONENT_BOX_HIDE = 'COMPONENT_BOX_HIDE'

export { COMPONENT_BOX_SHOW, COMPONENT_BOX_HIDE }
